module.exports = __webpack_public_path__ + "static/media/boy_in_clouds.d4d5419c.png";